import moment from "moment";

export const VEHICLE_OUT_OF_SERVICES_COLUMNS = (
  editRow,
  notTerminated,
  fromVehicle
) => {
  const columns = [
    {
      Header: "Vehicle Number",
      accessor: "VehicleNumber"
    },
    {
      Header: "Vehicle Description",
      accessor: "VehicleDescription"
    },
    {
      Header: "Out of Service Date",
      accessor: "OutOfServiceDate",
      Cell: ({ cell }) =>
        cell.value
          ? moment(new Date(cell.value).toISOString().slice(0, 10)).format(
              "MM/DD/YYYY"
            )
          : null
    },
    {
      Header: "Status",
      accessor: "StatusCodeDescription"
    },
    {
      Header: "Comment",
      accessor: "Comment"
    },
    {
      Header: "Created Date",
      accessor: "CreatedDateTime",
      Cell: ({ cell }) =>
        cell?.value ? moment.utc(cell.value).format("MM/DD/YYYY HH:mm") : null
    },
    {
      Header: "Created By",
      accessor: "CreatedBy"
    }
  ];
  if (!notTerminated) {
    columns.splice(0, 0, {
      Header: "Update Status",
      Cell: obj => editRow(obj)
    });
  }

  if (fromVehicle) {
    columns.splice(0, 2);
  }
  return columns;
};
